/** Booking details step — labels & helper copy */

export const bookingFormContentDefaults = {
  pageEyebrow: "Complete your booking",
  pageTitle: "Booking details",
  pageSubtitle:
    "Fill in your details — slot is the one you already chose on the previous step.",
  overviewLabel: "Overview",
  overviewTheatreLabel: "Theatre name:",
  overviewDateLabel: "Date:",
  overviewSlotLabel: "Time slot:",
  bookingDetailsSectionTitle: "Booking details",
  bookingNameLabel: "Booking Name *",
  bookingNamePlaceholder: "Booking Name",
  personsLabel: "Persons *",
  whatsappLabel: "WhatsApp *",
  whatsappPlaceholder: "10-digit number",
  emailLabel: "Email *",
  emailPlaceholder: "you@example.com",
  decorationLabel: "Decoration? *",
  decorationYesSuffix: " (+ ₹599)",
  eventLabel: "Event *",
  summaryTitle: "Booking summary",
  summaryPersons: "Persons",
  summaryPackage: "Theatre package",
  summaryDecoration: "Decoration",
  summaryTotal: "Total",
  summaryAdvance: "Advance payable",
  summaryAdvanceNote: "Includes ₹50 convenience fee where applicable.",
  summaryBalance: "Balance at venue",
  summaryFootnote: "Taxes as per theatre package. Add-ons in the next step.",
  slotsLeftSuffix: "slots left ·",
  backLabel: "Back",
  proceedLabel: "Proceed",
  missingSlotMessage: "Choose a theatre and time slot first.",
  backToTheatres: "Back to theatres",
};
